import { filterConfiguration } from 'app/components/filters/filters-panel/filter-configuration';
import { FilterDomain } from './filter-domain';
import { endpoint } from 'app/area/filters/constants';
import { FilterTypes } from 'app/components/filters/types';
import { customFilterFieldPostfix } from 'app/components/filters/filters-panel/constants';
import { userProfileConditionMapper } from 'app/components/filters/filters-panel/filter-types/filter-domain/user-profile';
import { getDefaultConditionTypesValueData } from '../default-condition-types-value-data';

export const myUnitConfiguration = {
  [FilterTypes.MyUnit]: filterConfiguration(
    FilterDomain,
    endpoint.filterOptionsFor,
    [customFilterFieldPostfix.userProfile]
  )
};

export const myUnitConditionMapper = (editingValues: any) =>
  userProfileConditionMapper(editingValues, FilterTypes.MyUnit, getDefaultConditionTypesValueData);
